module.exports = __webpack_public_path__ + "img/tom-grotta.7242f181.png";